import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Question: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 10 15" {...props}>
    <path d="M5 .707C2.709.707.833 2.54.833 4.783a.812.812 0 00.414.715.85.85 0 00.84 0 .812.812 0 00.413-.715c0-1.36 1.11-2.446 2.5-2.446s2.5 1.085 2.5 2.446c0 .846-.349 1.423-.92 2.012-.572.59-1.365 1.122-2.1 1.699a.809.809 0 00-.313.636v1.087a.812.812 0 00.413.716.85.85 0 00.84 0 .812.812 0 00.413-.716V9.53c.607-.454 1.32-.953 1.962-1.614.748-.77 1.372-1.81 1.372-3.133C9.167 2.54 7.29.707 5 .707zM5 12.12a1.1 1.1 0 00-1.111 1.087A1.1 1.1 0 005 14.293a1.1 1.1 0 001.111-1.086A1.1 1.1 0 005 12.12z" />
  </Icon>
);
